import { SEARCH_COMPONENT, TOGGLE_OPEN } from "../actions/types";

const initialState = {
  component: "",
  open: false,
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  switch (action.type) {
    case SEARCH_COMPONENT:
      return {
        ...state,
        component: action.payload,
      };
    case TOGGLE_OPEN:
      return {
        ...state,
        open: !state.open,
      };
    default:
      return state;
  }
}
